import comp from "./ChecklistTable";
export default comp;
